import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

export default defineNuxtPlugin(() => {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const config = useRuntimeConfig();

  // Set ScrollTrigger markers default based on runtime config
  ScrollTrigger.defaults({
    markers: config.public.gsapScrollTriggerMarkers,
  });

  return {
    provide: {
      gsap,
      ScrollTrigger,
      SplitText,
    },
  };
});
